import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import ModelList from './ModelList';
import models from './../../../../model/model';
import makes from './../../../../model/makes';
import generations from './../../../../model/generation';
import withRouter from '/src/components/misc/withRouter';

class ModelsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      generations: [],
      models: [],
      makeid: props.match.params.makeId
    };
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    Promise.all([
      makes.getById(this.state.makeid),
      models.modelsByMake(this.state.makeid, true, 2),
      generations.generationByMake(this.state.makeid, 2)
    ]).then(([make, models, generations]) => {
      document.title = `Admin - Generasjoner - ${make.name}`;
      this.setState({
        make: make,
        models: models,
        generations: generations
      });
    });
  }


  render() {
    if (this.state.models.length > 0) {
      return (
        <section>
          <div className="mf-model">
            <ol className="breadcrumb mf-margin-top-20">
              <li><Link to="/">Forsiden</Link></li>
              <li><Link to="/mypage/">Min side</Link></li>
              <li className="active">{this.state.make.name}</li>
            </ol>
            <h1 className="page-header">Generasjoner for <em>{this.state.make.name}</em></h1>
          </div>

          <ModelList make={this.state.make} models={this.state.models} generations={this.state.generations}/>
        </section>
      );
    }

    return (
      <Loading title="Bilmodeller" text="Laster generasjoner" />
    );
  }
}

export default withRouter(ModelsComponent);
